// class PredictiveSearch extends HTMLElement {
//   constructor() {
//     super();
//     this.input = this.querySelector('input[type="search"]');
//     this.predictiveSearchResults = this.querySelector('#predictive-search');

//     this.input.addEventListener('input', this.debounce((event) => {
//       this.onChange(event);
//     }, 300).bind(this));
//   }

//   onChange() {
//     const searchTerm = this.input.value.trim();

//     if (!searchTerm.length) {
//       this.close();
//       return;
//     }

//     this.getSearchResults(searchTerm);
//   }

//   async getSearchResults(searchTerm) {
//     try {
//       const [productsResponse, articlesResponse, collectionsResponse] = await Promise.all([
//         fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[type]=product`),
//         fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[type]=article`),
//         fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[type]=collection`)
//       ]);

//       if (!productsResponse.ok || !articlesResponse.ok || !collectionsResponse.ok) {
//         throw new Error('Search failed');
//       }

//       const [productsText, articlesText, collectionsText ] = await Promise.all([
//         productsResponse.text(),
//         articlesResponse.text(),
//         collectionsResponse.text()
//       ]);

//       // Parse both responses
//       const productsDoc = new DOMParser().parseFromString(productsText, 'text/html');
//       const articlesDoc = new DOMParser().parseFromString(articlesText, 'text/html');
//       const collectionsDoc = new DOMParser().parseFromString(collectionsText, 'text/html');

//       // Extract the results
//       const productsSection = productsDoc.querySelector('.predictive-search-products');
//       const articlesSection = articlesDoc.querySelector('.predictive-search-articles');
//       const collectionsSection = collectionsDoc.querySelector('.predictive-search-collections');

//       // Combine results
//       let combinedHTML = '<div class="predictive-search-wrapper">';
//       if (productsSection) combinedHTML += productsSection.outerHTML;
//       if (articlesSection) combinedHTML += articlesSection.outerHTML;
//       if (collectionsSection) combinedHTML += collectionsSection.outerHTML;
//       combinedHTML += '</div>';

//       this.predictiveSearchResults.innerHTML = combinedHTML;
//       this.open();

//     } catch (error) {
//       this.close();
//       console.error('Search error:', error);
//     }
//   }

//   open() {
//     this.predictiveSearchResults.style.display = 'block';
//   }

//   close() {
//     this.predictiveSearchResults.style.display = 'none';
//   }

//   debounce(fn, wait) {
//     let t;
//     return (...args) => {
//       clearTimeout(t);
//       t = setTimeout(() => fn.apply(this, args), wait);
//     };
//   }
// }

// customElements.define('predictive-search', PredictiveSearch);
/* Part numbers typed without their separators (A06B6079H106, 6ES72162BD230XB0) find nothing in the
   storefront search index: rebuild the catalog form for the common prefixes so an empty products group
   can be retried once (L6-8). Returns '' when no rule applies. Same rules as hp-hero.js; templates/search.liquid
   reads this global for its "Did you mean" line. */
function partNumberAlias(term) {
  var t = String(term || '').trim().toUpperCase();
  if (!/^[A-Z0-9]{6,20}$/.test(t) || !/\d/.test(t) || !/[A-Z]/.test(t)) return '';
  var rules = [
    [/^(A\d[0-9A-Z]{2})(\d{4})([0-9A-Z]{4})$/, '$1-$2-$3'],            /* FANUC A06B-6079-H106, A20B-2101-0025, A860-0360-T001 */
    [/^([136][A-Z]{2}\d{4})([0-9A-Z]{5})([0-9A-Z]{4})$/, '$1-$2-$3'],  /* Siemens 6ES7216-2BD23-0XB0, 6SL3120-1TE21-0AA4, 1FK7042-5AF71-1AG0 */
    [/^([36][A-Z]{2}\d{4})([0-9A-Z]{5})$/, '$1-$2'],                   /* Siemens 3RT2016-1BB41, 6EP1334-3BA10 */
    [/^(SG[A-Z]{2,3})(\d{2,3}[A-Z][0-9A-Z]*)$/, '$1-$2'],              /* Yaskawa SGDV-120A01A, SGMGV-13ADC61 */
    [/^(CIMR|JUSP|SGDR)([A-Z][0-9A-Z]+)$/, '$1-$2'],                   /* Yaskawa CIMR-VU2A0010FAA, JUSP-NS100 */
    [/^(MR)(J\d[A-Z]?)(\d{2,4}[0-9A-Z]*)$/, '$1-$2-$3'],               /* Mitsubishi MR-J2S-100A, MR-J4-200B */
    [/^(H[CFG])([A-Z]{2,3}\d[0-9A-Z]*)$/, '$1-$2'],                    /* Mitsubishi HC-KFS43, HG-KR43 */
    [/^(FR)([A-Z]\d{3})(\d{5}[0-9A-Z]*)$/, '$1-$2-$3'],                /* Mitsubishi FR-A740-00250 */
    [/^(AC[SH]\d{3})(\d{2}[A-Z]?)(\d{2}A\d)(\d)$/, '$1-$2-$3-$4']      /* ABB ACS580-01-12A7-4, ACS355-03E-08A8-4 */
  ];
  for (var i = 0; i < rules.length; i++) {
    if (rules[i][0].test(t)) return t.replace(rules[i][0], rules[i][1]);
  }
  return '';
}

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.container = this.querySelector('#predictive-search');
    this.isOpen = false;
    this.seq = 0; /* the newest term's response wins */

    this.input.addEventListener('input', this.debounce(() => {
      this.onChange();
    }, 300));

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.close();
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }


  async getSearchResults(searchTerm, isRetry) {
    const seq = isRetry ? this.seq : ++this.seq;
    try {
      // data-endpoint="{{ routes.predictive_search_url }}" keeps the market / locale prefix
      // (e.g. /de-de/search/suggest); instances without the attribute keep the legacy default.
      const endpoint = this.getAttribute('data-endpoint') || '/search/suggest';
      // Fetch all 3 resource types in parallel with Promise.all
      const [productsResponse, collectionsResponse, articlesResponse] = await Promise.all([
        fetch(`${endpoint}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=product`),
        fetch(`${endpoint}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=collection`),
        fetch(`${endpoint}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=article`)
      ]);

      if (!productsResponse.ok || !collectionsResponse.ok || !articlesResponse.ok) {
        throw new Error('Search failed');
      }

      const [productsText, collectionsText, articlesText] = await Promise.all([
        productsResponse.text(),
        collectionsResponse.text(),
        articlesResponse.text()
      ]);

      // Parse all responses
      const productsDoc = new DOMParser().parseFromString(productsText, 'text/html');
      const collectionsDoc = new DOMParser().parseFromString(collectionsText, 'text/html');
      const articlesDoc = new DOMParser().parseFromString(articlesText, 'text/html');

      // Extract sections
      const productsSection = productsDoc.querySelector('.predictive-search-products__wrapper');
      const collectionsSection = collectionsDoc.querySelector('.predictive-search-collections');
      const articlesSection = articlesDoc.querySelector('.predictive-search-articles');
      if (seq !== this.seq) return; /* superseded by a newer term */

      // No products for a part number typed without separators: retry once with the catalog form.
      if (!productsSection && !isRetry) {
        const alias = partNumberAlias(searchTerm);
        if (alias && alias !== searchTerm) {
          return this.getSearchResults(alias, true);
        }
      }

      // Check if we have any results
      if (!productsSection && !collectionsSection && !articlesSection) {
        this.close();
        return;
      }

      // Build vertical stack — each section renders its own header + rows
      let wrapperHTML = `<div class="predictive-search-wrapper divide-y divide-zinc-100 pb-2">
        ${productsSection ? productsSection.outerHTML : ''}
        ${collectionsSection ? collectionsSection.outerHTML : ''}
        ${articlesSection ? articlesSection.outerHTML : ''}
      </div>`;

      // Remove old results before inserting new ones
      const oldResults = this.container.querySelector('.predictive-search-wrapper');
      if (oldResults) oldResults.remove();

      this.container.insertAdjacentHTML('afterbegin', wrapperHTML);
      this.open();

    } catch (error) {
      this.close();
      console.error('Search error:', error);
    }
  }


  open() {
    if (!this.isOpen) {
      this.isOpen = true;
      this.container.classList.add('open');
      this.input.setAttribute('aria-expanded', 'true');
    }

    requestAnimationFrame(() => {
      const wrapper = this.container.querySelector('.predictive-search-wrapper');
      if (wrapper) {
        this.container.style.maxHeight = Math.min(wrapper.scrollHeight, 480) + 'px';
      }
    });
  }

  close() {
    if (!this.isOpen) return;

    this.isOpen = false;
    this.container.style.maxHeight = '0';
    this.container.classList.remove('open');
    this.hideLoading();
    this.input.setAttribute('aria-expanded', 'false');

    setTimeout(() => {
      const oldResults = this.container.querySelector('.predictive-search-wrapper');
      if (oldResults) oldResults.remove();
    }, 200);
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);